export const IndexPageSectionRouteENUM = {
  NEWS: {
    name: 'NEWS',
    route: 'news'
  },
  ENROLL_ENTER: {
    name: 'ENROLL_ENTER',
    route: 'enroll/login'
  },
  ENROLL_RESULTS: {
    name: 'ENROLL_RESULTS',
    route: 'enroll/exam/results'
  },
  REGION_COLLEGE_PROFESSIONS: {
    name: 'REGION_COLLEGE_PROFESSIONS',
    route: 'region-professions'
  },
  REGION_ENROLLS: {
    name: 'REGION_ENROLLS',
    route: 'region-enrolls'
  },
  REGION_APPLICANTS: {
    name: 'REGION_APPLICANTS',
    route: 'region-applicants'
  }
  // REGISTER_GRADUATE: {
  //   name: 'REGISTER_GRADUATE',
  //   route: 'register/graduates'
  // }
};



// WEBPACK FOOTER //
// ./src/app/common/enums/index-page-section-route.enum.ts